/* tinyme-uploader-wimp.js – v2025-07-09  */
/* ----------------------------------------
   1) 写真アップロード完了までは自動
   2) ボタンを押した時点でプレビュー生成 API を呼ぶ
   3) プレビュー画像を表示し、カートを解禁
-----------------------------------------*/

// 多重実行防止：buy_buttonsブロックが2つある等でスクリプトが複数回動いても1回だけ初期化する
if (window._tinyMeWimpInitialized) {
  console.warn('[wimp] Already initialized. Skipping duplicate initialization.');
} else {
  window._tinyMeWimpInitialized = true;
  _initTinyMeWimp();
}


function _initTinyMeWimp() {

document.addEventListener('DOMContentLoaded', () => {
  window.previewReady = false;
  window.currentJobId = null;
  /* ---------- DOM 要素 ---------- */
  const photoInput   = document.querySelector('#tinyme-photo');          // <input type="file">
  const previewBtn   = document.querySelector('#tinyme-generate-preview');
  const progressBar  = document.getElementById('tinyme-progress');       // <progress hidden>
  const previewWrap  = document.getElementById('tinyme-preview-wrapper');// <div hidden>
  const previewImg   = document.getElementById('tinyme-preview-img');    // <img>
  
  /* モーダル関連 */
  const modal        = document.getElementById('tm-preview-modal');
  const modalImg     = document.getElementById('tm-modal-img');
  const modalNextBtn = document.getElementById('tm-modal-next');
  const modalDownloadBtn = document.getElementById('tm-modal-download');
  const previewCloseBtn = modal.querySelector('[data-close]');
  const coverBlock   = document.getElementById('tinyme-cover-selector'); // ← カバー選択 UI ラッパー

  /* メールステップ用 DOM */
  const stepPreview      = document.getElementById('tm-modal-step-preview');
  const stepEmail        = document.getElementById('tm-modal-step-email');
  const stepDone         = document.getElementById('tm-modal-step-done');
  const emailTriggerLink = document.getElementById('tm-modal-email-trigger');
  const emailInput       = document.getElementById('tm-modal-email-input');
  const consentCheck     = document.getElementById('tm-modal-consent');
  const emailSubmitBtn   = document.getElementById('tm-modal-email-submit');
  const emailBackBtn     = document.getElementById('tm-modal-email-back');
  const orderFromDoneBtn = document.getElementById('tm-modal-order-from-done');

  /* 動画モーダル関連 */
  let videoModal = null;
  let videoElement = null;
  let imageElement = null;
  let isVideoPlaying = false;


  /* hidden inputs（line-item-property 用） */
  const propPhotoKey   = document.querySelector('#prop-photo-key');
  const propPreviewJob = document.querySelector('#prop-preview-job');
  const propPreviewUrl = document.querySelector('#prop-preview-url');

  // プレフィックスを上書き
  propPhotoKey.name   = 'properties[_photo_key]';
  propPreviewJob.name = 'properties[_preview_job_id]';
  propPreviewUrl.name = 'properties[_preview_url]';

  /* 入力欄 */
  const nameEl     = document.querySelector('#tinyme-name');
  const ageEl      = document.querySelector('#tinyme-age');
  const monthEl    = document.querySelector('[name="properties[birthday_month]"]');
  const dayEl      = document.querySelector('[name="properties[birthday_day]"]');
  const bookSlugEl = document.querySelector('[name="book_slug"]');

  /* 性別はラジオ or ボタン切替どちらでも動くよう関数化 */
  const getGender = () => {
    const checked = document.querySelector('input[name="gender"]:checked');
    if (checked) return checked.value;
    const active  = document.querySelector('.tm-gender-button.active');
    return active ? active.dataset.gender : '';
  };

  /* Dawn の「カートに入れる」ボタン */
  const addBtn = document.querySelector('[data-add-to-cart]');
    if (addBtn) addBtn.disabled = true;         // ページ読込直後は常に無効
  if (addBtn) {
    addBtn.disabled = true;         // ページ読込直後は常に無効
    addBtn.style.display = 'none';  // 初期状態で非表示
  }

  /* ---------- ヘルパー関数 ---------- */

  /** モーダルのステップを切り替える */
  function showModalStep(step) {
    [stepPreview, stepEmail, stepDone].forEach(s => s?.classList.add('hidden'));
    step?.classList.remove('hidden');
  }

  /**
   * 月・日・「次の誕生日で迎える年齢」から実際の生年月日 YYYY-MM-DD を返す。
   *
   * フォームの「お誕生日がきたら N歳」は次の誕生日で迎える年齢を表すため、
   *   生まれ年 = 次の誕生日の年 - N
   * で正確な生年月日を逆算できる。
   *
   * Klaviyo の Date-Based Flow (annually) はこの実際の生年月日の月・日を
   * 毎年参照してトリガーするため、年次リマインダーが永続的に機能する。
   * また、Flow 内で Child Birthday の相対日付比較により
   * 現在の年齢を動的に判定できる（stale な Child Age プロパティ不要）。
   */
  function actualBirthDate(month, day, ageAtNextBirthday) {
    if (!month || !day || !ageAtNextBirthday) return '';
    const today = new Date();
    const thisYear = today.getFullYear();
    const m = parseInt(month);
    const d = parseInt(day);
    const age = parseInt(ageAtNextBirthday);
    // 今年の誕生日がまだ来ていなければ次の誕生日は今年、過ぎていれば来年
    const thisYearBday = new Date(thisYear, m - 1, d);
    const nextBdayYear = thisYearBday > today ? thisYear : thisYear + 1;
    const birthYear = nextBdayYear - age;
    const mm = String(m).padStart(2, '0');
    const dd = String(d).padStart(2, '0');
    return `${birthYear}-${mm}-${dd}`;
  }

  /**
   * 実際の生年月日から 1〜9歳の誕生日日付をまとめて返す。
   * Klaviyo の Date-Based Flow (Repeats: Never) でそれぞれの誕生日の
   * 30日前に1回だけメールを送るために使用する。
   *
   *   wimp 案内: Child 1st〜4th Birthday（発火時の現在年齢 = 0〜3歳）
   *   bd2  案内: Child 5th〜9th Birthday（発火時の現在年齢 = 4〜8歳）
   *
   * 登録時点ですでに過去になった誕生日は Klaviyo がトリガーしないため
   * 途中年齢からの登録でも自然に正しい誕生日分だけ動作する。
   */
  function computeAgeBirthdays(birthDate) {
    if (!birthDate) return {};
    const [byStr, bmStr, bdStr] = birthDate.split('-');
    const birthYear = parseInt(byStr);
    const ordinals  = ['1st','2nd','3rd','4th','5th','6th','7th','8th','9th'];
    const result    = {};
    ordinals.forEach((ord, i) => {
      result[`Child ${ord} Birthday`] = `${birthYear + i + 1}-${bmStr}-${bdStr}`;
    });
    return result;
  }

  /**
   * モーダルを閉じて注文フローへ進む共通処理
   */
  function proceedToOrder() {
    modal.close();
    coverBlock?.classList.remove('hidden');
    attachCoverListeners();
    scrollToCover();
    const defaultRadio = document.querySelector('#tinyme-cover-selector input[name="variant_custom"]:checked');
    if (defaultRadio) syncVariantId(defaultRadio.value);
  }

/* ---------- API エンドポイント ---------- */
  const API_BASE    = 'https://91tczp7f0e.execute-api.ap-northeast-1.amazonaws.com/prod'; // presign用は従来のまま
  const PRESIGN_URL = `${API_BASE}/tinyme-presign`;
  // プレビュー生成APIは新しいFunction URLに変更
  const PREVIEW_URL = 'https://dttwr2bahhm6qdgm6hcsryytfm0qpvrv.lambda-url.ap-northeast-1.on.aws/';

  let uploadedKey = null;                     // S3 キー
  previewBtn.disabled = true;                 // 写真未選択では押せない

  /**
   * メールリンクからの復帰処理
   * URL に ?preview_job_id=xxx が付いている場合、DynamoDB から画像を取得してモーダルを表示する。
   */
  /**
   * 保存済み／メールリンクの book_meta からフォーム入力欄を復元する。
   * 写真ファイル自体は再アップロードできないため対象外（photo_key は
   * hidden input 経由でカートには引き継がれる）。
   */
  function restoreFormFields(fields) {
    if (!fields) return;
    if (fields.name && nameEl) nameEl.value = fields.name;
    if (fields.birthday_month && monthEl) monthEl.value = fields.birthday_month;
    if (fields.birthday_day && dayEl) dayEl.value = fields.birthday_day;
    if (fields.age && ageEl) ageEl.value = fields.age;
    if (fields.gender) {
      document.querySelectorAll('.tm-gender-button').forEach(btn => {
        btn.classList.toggle('active', btn.dataset.gender === fields.gender);
      });
      const genderInput = document.getElementById('tinyme-gender');
      if (genderInput) genderInput.value = fields.gender;
    }
  }

  /** バナー・ページ再訪から、保存済みプレビューへ復帰する */
  async function restoreFromSaved(saved) {
    if (!saved) return;
    const fresh = await window.TinyMePreviewResume?.fetchFreshStatus(saved.jobId);
    const imageUrl = fresh?.image_url || saved.imageUrl;
    restoreFormFields(fresh?.book_meta || saved.formFields);
    window.currentJobId  = saved.jobId;
    propPreviewJob.value = saved.jobId;
    propPreviewUrl.value = imageUrl;
    if (modalImg) modalImg.src = imageUrl;
    showModalStep(stepPreview);
    if (typeof modal.showModal === 'function' && !modal.open) modal.showModal();
    if (addBtn) { addBtn.style.display = 'block'; addBtn.disabled = false; }
    window.previewReady = true;
  }

  (async function resumeFromUrlParam() {
    const params = new URLSearchParams(window.location.search);
    const jobId  = params.get('preview_job_id');
    if (!jobId) return;
    try {
      const r    = await fetch(`https://lyskvdawy5qlnhqmzhpskyazoe0zweyb.lambda-url.ap-northeast-1.on.aws/?preview_job_id=${jobId}`);
      const data = await r.json();
      if (data.status === 'done' && data.image_url) {
        if (modalImg) modalImg.src = data.image_url;
        window.currentJobId  = jobId;
        propPreviewJob.value = jobId;
        propPreviewUrl.value = data.image_url;
        restoreFormFields(data.book_meta);
        showModalStep(stepPreview);
        if (typeof modal.showModal === 'function' && !modal.open) modal.showModal();
        if (addBtn) { addBtn.style.display = 'block'; addBtn.disabled = false; }
        window.previewReady = true;
      }
    } catch (e) {
      console.warn('[wimp] URL param resume failed:', e);
    }
  })();

  /**
   * ページ再訪時（?preview_job_id= 無し）に、7日以内の保存済みプレビューが
   * あればフローティングバナーで「続きから注文する」導線を出す。
   */
  (function checkSavedPreviewOnLoad() {
    if (new URLSearchParams(window.location.search).get('preview_job_id')) return;
    const bookSlug = bookSlugEl?.value || 'wimp';
    const saved = window.TinyMePreviewResume?.load(bookSlug);
    if (!saved) return;
    window.TinyMePreviewResume.showBanner({
      bookSlug,
      imageUrl: saved.imageUrl,
      onResume: () => restoreFromSaved(saved)
    });
  })();

  /* ---------- Klaviyo ---------- */
  const KLAVIYO_PUBLIC_KEY = 'Rze84L';
  const KLAVIYO_LIST_ID    = 'RsNZz5';

  async function subscribeToKlaviyo({ email, childName, birthday, childAge, previewJobId, imageUrl, orderUrl }) {
    try {
      const res = await fetch(
        `https://a.klaviyo.com/client/subscriptions/?company_id=${KLAVIYO_PUBLIC_KEY}`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'revision': '2024-02-15',
          },
          body: JSON.stringify({
            data: {
              type: 'subscription',
              attributes: {
                custom_source: 'TinyMeTales Preview Modal',
                profile: {
                  data: {
                    type: 'profile',
                    attributes: {
                      email,
                      properties: {
                        'Child Name':             childName,
                        'Child Birthday':         birthday,
                        'Child Age':              childAge,
                        ...computeAgeBirthdays(birthday),
                        'Last Preview Product':   'wimp',
                        'Last Preview Image URL': imageUrl,
                        'Last Preview Job ID':    previewJobId,
                        'Last Order URL':         orderUrl,
                      },
                    },
                  },
                },
              },
              relationships: {
                list: {
                  data: {
                    type: 'list',
                    id: KLAVIYO_LIST_ID,
                  },
                },
              },
            },
          }),
        }
      );
      if (!res.ok) {
        const err = await res.text();
        console.warn('[wimp] Klaviyo subscribe failed:', res.status, err);
      }
    } catch (e) {
      console.warn('[wimp] Klaviyo subscribe error:', e);
    }
  }

  /* ---------- ヘルパー ---------- */
  async function getPresign(filename, mime) {
    const res = await fetch(PRESIGN_URL, {
      method : 'POST',
      headers: { 'Content-Type': 'application/json' },
      body   : JSON.stringify({ filename, type: mime })
    });
    if (!res.ok) throw new Error('presign error');
    return res.json();                        // { url, fields, key }
  }

  async function uploadToS3(presign, file) {
    return new Promise((resolve, reject) => {
      const fd = new FormData();
      Object.entries(presign.fields).forEach(([k, v]) => fd.append(k, v));
      fd.append('file', file);

      const xhr = new XMLHttpRequest();
      xhr.open('POST', presign.url);

      /* 進捗表示 */
      xhr.upload.onprogress = e => {
        if (!progressBar) return;
        progressBar.hidden = false;
        progressBar.max    = e.total;
        progressBar.value  = e.loaded;
      };

      xhr.onload  = () => (xhr.status >= 200 && xhr.status < 300) ? resolve() : reject(new Error('S3 upload error'));
      xhr.onerror = () => reject(new Error('S3 upload error'));
      xhr.send(fd);
    });
  }

  /* ---------- 画像アップロード ---------- */
  photoInput.addEventListener('change', async () => {
    const file = photoInput.files?.[0];
    if (!file) return;

    previewBtn.disabled = true;
    try {
      /* ① presign → ② S3 */
      const ext      = file.name.split('.').pop() || 'jpg';
      const presign  = await getPresign(`upload-${crypto.randomUUID()}.${ext}`, file.type || 'application/octet-stream');
      await uploadToS3(presign, file);

      /* ③ 成功したらキーを保持・hidden に保存・ボタン活性化 */
      uploadedKey         = presign.key;
      propPhotoKey.value  = presign.key;
      previewBtn.disabled = false;
    } catch (err) {
      alert('画像アップロードに失敗しました。もう一度お試しください');
      console.error(err);
    } finally {
      if (progressBar) progressBar.hidden = true;
    }
  });

  /* ---------- プレビュー生成 (ボタンクリック) ---------- */
  previewBtn.addEventListener('click', async () => {
    if (!uploadedKey)     { alert('先に写真をアップロードしてください'); return; }
    if (!nameEl.value.trim()) { alert('お名前を入力してください'); return; }

    const payload = {
      key            : uploadedKey,
      name           : nameEl.value.trim(),
      gender         : getGender(),
      age            : ageEl.value,
      birthday_month : monthEl.value,
      birthday_day   : dayEl.value,
      book_slug      : bookSlugEl?.value || 'wimp'
      // job_id は Lambda が自動発行
    };

    previewBtn.disabled = true;
    const originalLabel = previewBtn.textContent;
    previewBtn.textContent = '生成中…';

    try {
      /* 動画モーダルを表示 */
      showVideoModal();

      /* ④ Lambda へリクエスト */
      const res = await fetch(PREVIEW_URL, {
        method : 'POST',
        headers: { 'Content-Type': 'application/json' },
        body   : JSON.stringify(payload)
      });
      if (!res.ok) throw new Error('preview api error');

      const { preview_job_id } = await res.json();
      
      /* ② preview_job_id を覚えてポーリング開始 */
      pollJobStatus(preview_job_id);

      /* ⑤ hidden に保持 */
      propPreviewJob.value = preview_job_id  ?? '';

            /* 回転メッセージ用のjobIdを設定 */
      window.currentJobId = preview_job_id;
      
      /* ★ Facebook Pixel に PreviewStarted イベントを送信 */
      const sendPreviewStartedEvent = () => {
        if (typeof window.fbq === 'function') {
          try {
            window.fbq('trackCustom', 'PreviewStarted', {
              job_id: preview_job_id,
              content_name: 'TinyMeTales cover preview',
              value: 0,
              currency: 'JPY'
            });
            console.log('✅ PreviewStarted event sent to Facebook Pixel', { job_id: preview_job_id });
          } catch (error) {
            console.error('❌ Error sending PreviewStarted event:', error);
          }
        } else {
          console.warn('⚠️ Facebook Pixel (fbq) is not available');
        }
      };

      // Pixelが既に読み込まれている場合は即座に送信、そうでなければ待機
      if (typeof window.fbq === 'function') {
        sendPreviewStartedEvent();
      } else {
        // Pixelの読み込みを待つ（最大5秒）
        let attempts = 0;
        const maxAttempts = 50; // 5秒間（100ms × 50）
        const checkPixel = setInterval(() => {
          attempts++;
          if (typeof window.fbq === 'function') {
            clearInterval(checkPixel);
            sendPreviewStartedEvent();
          } else if (attempts >= maxAttempts) {
            clearInterval(checkPixel);
            console.warn('⚠️ Facebook Pixel did not load within timeout period');
          }
        }, 100);
      }
      
      /* ⑥ UI 更新（URL はまだ無いので文言だけ変更） */
      previewBtn.textContent = '生成中…';

    } catch (err) {
      alert('プレビュー生成に失敗しました。もう一度お試しください');
      console.error(err);
      previewBtn.textContent = 'もう一度試す';
      if (addBtn) {
        addBtn.style.display = 'none';
        addBtn.disabled = true;
      }
      closeVideoModal();
    } finally {
      previewBtn.disabled = true;
    }
  });
  
  /* モバイルデバイスかどうかを判定 */
  const isMobileDevice = () => {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ||
           (window.innerWidth <= 768 && 'ontouchstart' in window);
  };

  /* モーダル→「イラストをダウンロード」ボタン */
  modalDownloadBtn?.addEventListener('click', async (e) => {
    e.preventDefault();
    if (modalImg && modalImg.src) {
      try {
        // fetch APIで画像をBlobとして取得
        const response = await fetch(modalImg.src);
        const blob = await response.blob();
        
        // モバイルデバイスでShare APIが利用可能な場合
        if (isMobileDevice() && navigator.share) {
          try {
            const file = new File([blob], 'preview-illustration.jpg', { type: 'image/jpeg' });
            await navigator.share({
              files: [file],
              title: 'プレビューイラスト',
              text: '表紙のプレビューイラスト'
            });
            // シェア成功時はここで終了（ダウンロード処理は実行しない）
            return;
          } catch (shareError) {
            // AbortError（ユーザーがキャンセル）の場合は何もしない
            if (shareError.name === 'AbortError') {
              return;
            }
            // その他のエラー（NotSupportedErrorなど）の場合は、ダウンロード処理に進む
            console.log('Share APIエラー:', shareError);
          }
        }

        // PCまたはShare APIが使えない場合: ダウンロードフォルダに保存
        const blobUrl = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = blobUrl;
        link.download = 'preview-illustration.jpg'; // ダウンロード時のファイル名
        link.style.display = 'none';
        document.body.appendChild(link);
        link.click();
        
        // クリーンアップ
        document.body.removeChild(link);
        window.URL.revokeObjectURL(blobUrl);
      } catch (error) {
        console.error('ダウンロードエラー:', error);
        // フォールバック: 新しいタブで開く（モーダルは閉じない）
        window.open(modalImg.src, '_blank');
      }
    }
  });

  /* モーダル→「表紙タイプを選ぶ」ボタン */
  modalNextBtn?.addEventListener('click', (e) => {
    e.preventDefault();
    proceedToOrder();
  });

  /* ── メールステップ: ステップ切り替え ── */

  emailTriggerLink?.addEventListener('click', (e) => {
    e.preventDefault();
    showModalStep(stepEmail);
    emailInput?.focus();
  });

  emailBackBtn?.addEventListener('click', () => {
    showModalStep(stepPreview);
  });

  /* ── メールステップ: Klaviyo へ送信 ── */

  emailSubmitBtn?.addEventListener('click', async () => {
    const email = emailInput?.value.trim();

    if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      emailInput?.focus();
      alert('正しいメールアドレスを入力してください');
      return;
    }
    if (!consentCheck?.checked) {
      alert('メールでのご案内への同意が必要です');
      return;
    }

    const productBase  = window.location.origin + window.location.pathname;
    const orderUrl     = `${productBase}?preview_job_id=${encodeURIComponent(window.currentJobId || '')}`;
    const childName    = nameEl?.value?.trim() || '';
    const childAge     = ageEl?.value || '';
    const birthday     = actualBirthDate(monthEl?.value, dayEl?.value, childAge);
    const previewJobId = window.currentJobId || '';
    const imageUrl     = modalImg?.src || '';

    window._learnq = window._learnq || [];

    /* ① 購読登録 */
    await subscribeToKlaviyo({ email, childName, birthday, childAge, previewJobId, imageUrl, orderUrl });

    /* ② プロフィール更新 */
    _learnq.push(['identify', {
      '$email':                 email,
      'Child Name':             childName,
      'Child Birthday':         birthday,
      'Child Age':              childAge,
      ...computeAgeBirthdays(birthday),
      'Last Preview Product':   'wimp',
      'Last Preview Image URL': imageUrl,
      'Last Preview Job ID':    previewJobId,
      'Last Order URL':         orderUrl,
    }]);

    /* ③ イベント送信（フォローアップ Flow のトリガー） */
    _learnq.push(['track', 'Preview Email Requested', {
      preview_job_id: previewJobId,
      image_url:      imageUrl,
      product:        'wimp',
      child_name:     childName,
      order_url:      orderUrl,
    }]);

    emailSubmitBtn.disabled = true;
    showModalStep(stepDone);
  });

  /* ── 送信完了ステップから注文へ ── */

  orderFromDoneBtn?.addEventListener('click', (e) => {
    e.preventDefault();
    proceedToOrder();
  });

  
function pollJobStatus(
  jobId,
  { firstDelayMs = 30_000, intervalMs = 5_000, maxAttempts = 180 } = {}
) {
  let attempt = 0;

  const check = async (intervalId) => {
    attempt++;

    try {
      const r = await fetch(
        `https://lyskvdawy5qlnhqmzhpskyazoe0zweyb.lambda-url.ap-northeast-1.on.aws/?preview_job_id=${jobId}`
      );
      const data = await r.json();

      if (data.status === 'done') {
        clearInterval(intervalId);
        
        /* 動画モーダルを閉じる */
        closeVideoModal();
        
         /* ▼ 小さなプレビュー（要素が存在しない場合はスキップ） */
        if (previewImg && previewWrap) {
          previewImg.onload = () => {
            previewWrap.hidden = false;          // hidden 属性を外す
            previewWrap.classList?.remove('hidden'); // hidden クラスも外す
          };
          previewImg.src = data.image_url;
        } else {
          console.log('ℹ️ Small preview elements not found, skipping...');
        }
    
         /* ▼ モーダル表示 */
        if (modalImg) {
          modalImg.src = data.image_url;
        } else {
          console.warn('⚠️ modalImg element not found');
        }
        
        /* --- showModal() が使えない環境へのフォールバック --- */
        if (modal) {
          showModalStep(stepPreview);
          if (typeof modal.showModal === 'function') {
            if (!modal.open) modal.showModal();
          } else {
            modal.classList.remove('hidden');
          }
        } else {
          console.warn('⚠️ modal element not found');
        }

        window.previewReady = true;
        propPreviewUrl.value = data.image_url;

        // プレビュー表示時にカートボタンを表示して有効にする
        if (addBtn) {
          addBtn.style.display = 'block';
          addBtn.disabled = false;
        }

        // 生成完了時点で自動保存（タブを閉じられた場合の保険）
        window.TinyMePreviewResume?.save(bookSlugEl?.value || 'wimp', {
          jobId: jobId,
          imageUrl: data.image_url,
          formFields: {
            name: nameEl?.value || '',
            gender: getGender(),
            age: ageEl?.value || '',
            birthday_month: monthEl?.value || '',
            birthday_day: dayEl?.value || '',
          },
        });

        /* ★ Facebook Pixel に PreviewGenerated イベントを送信 */
        const sendPreviewEvent = () => {
          if (typeof window.fbq === 'function') {
            try {
              window.fbq('trackCustom', 'PreviewGenerated', {
                job_id: jobId,
                content_name: 'TinyMeTales cover preview',
                value: 0,
                currency: 'JPY'
              });
              console.log('✅ PreviewGenerated event sent to Facebook Pixel', { job_id: jobId });
            } catch (error) {
              console.error('❌ Error sending PreviewGenerated event:', error);
            }
          } else {
            console.warn('⚠️ Facebook Pixel (fbq) is not available');
          }
        };

        // Pixelが既に読み込まれている場合は即座に送信、そうでなければ待機
        if (typeof window.fbq === 'function') {
          sendPreviewEvent();
        } else {
          // Pixelの読み込みを待つ（最大5秒）
          let attempts = 0;
          const maxAttempts = 50; // 5秒間（100ms × 50）
          const checkPixel = setInterval(() => {
            attempts++;
            if (typeof window.fbq === 'function') {
              clearInterval(checkPixel);
              sendPreviewEvent();
            } else if (attempts >= maxAttempts) {
              clearInterval(checkPixel);
              console.warn('⚠️ Facebook Pixel did not load within timeout period');
            }
          }, 100);
        }
        
        return;
      }
    } catch (e) {
      console.error('status check error', e); // ネットワーク落ちても次ループ
    }

    /* ▼▼ 上限に達した？ ▼▼ */
    if (attempt >= maxAttempts) {
      clearInterval(intervalId);
      alert('プレビュー生成がタイムアウトしました。もう一度お試しください。');
      if (addBtn) {
        addBtn.style.display = 'none';
        addBtn.disabled = true;
      }
      closeVideoModal();
    }
  };

  /* 30 秒待ってから開始 */
  setTimeout(() => {
    const id = setInterval(() => check(id), intervalMs);
    check(id); // 1 回目を即実行
  }, firstDelayMs);
}

  
  /* ---------- 共通：hidden・product-form を更新 ---------- */
  function syncVariantId(variantId) {
    const hiddenId   = document.querySelector('form[action=\"/cart/add\"] input[name=\"id\"]');
    const productFrm = document.querySelector('product-form');
    document.querySelectorAll('[data-add-to-cart]')
      .forEach(btn => (btn.dataset.variantId = variantId));
    if (hiddenId)   hiddenId.value   = variantId;
    if (productFrm) {
   /* Dawn が参照する currentVariant も Hard/Soft に更新 */
      productFrm.currentVariant = { id: Number(variantId) };   // ★ 追加
    }
  }
  
  /* ---------- カバーを選んだら ---------- */
  function attachCoverListeners() {
    document
      .querySelectorAll('#tinyme-cover-selector input[name=\"variant_custom\"]')
      .forEach(radio => {
        radio.addEventListener('change', () => {
          syncVariantId(radio.value);
        });
      });
  }

  /* -----------------------------------------------------
   Dawn 15 では <product-form> が submit 直前に
   this.currentVariant.id で hidden を上書きする。
   → さらにその直前で TinyMe の選択値を再度書き込む。
   ----------------------------------------------------- */

(function forceTinyMeVariant() {
  const productFormEl = document.querySelector('product-form');
  if (!productFormEl) return;

  // 内部の <form> を取得
  const innerForm = productFormEl.querySelector('form');
  if (!innerForm) return;

  // ★ capture フェーズで実行させる (第三引数 true)
  innerForm.addEventListener(
    'submit',
    () => {
      const chosen = document.querySelector(
        '#tinyme-cover-selector input[name="variant_custom"]:checked'
      );
      if (!chosen) return;

      // hidden input を確実に書き換える
      const hiddenId = innerForm.querySelector('input[name="id"]');
      if (hiddenId) hiddenId.value = chosen.value;

      // Dawn が参照する currentVariant も更新
      productFormEl.currentVariant = { id: Number(chosen.value) };
    },
    true // ← capture!
  );
})();

/* ------ プレビューを閉じたらカバー選択へスムーズスクロール ------ */
 function scrollToCover() {
   coverBlock?.scrollIntoView({ behavior: 'smooth', block: 'start' });
   requestAnimationFrame(() => {
     // 固定ヘッダーで隠れる時は解除
     // window.scrollBy({ top: -80, behavior: 'instant' });
   });
 }

 // 重複するイベントリスナーを削除（上記のmodalNextBtnイベントリスナーで処理済み）

 // dialog が閉じ切ったら必ずスクロール
 modal.addEventListener('close', scrollToCover);

 // モーダルが閉じられた時の処理（カートボタンは表紙選択後にのみ有効化）
 modal.addEventListener('close', () => {
   // プレビュー完了後、表紙選択後のみカートボタンを有効化
   // カートボタンの表示・有効化は表紙選択イベントで行う
   
   // Dawnテーマのproduct-formコンポーネントのcurrentVariantも更新
   const productForm = document.querySelector('product-form');
   if (productForm) {
     // 既に選択されているカバーをチェック
     const selectedCover = document.querySelector(
       '#tinyme-cover-selector input[name="variant_custom"]:checked'
     );
     
     if (selectedCover) {
       productForm.currentVariant = { id: Number(selectedCover.value) };
     }
   }
 });

 // モーダルを閉じたら自動保存し、「続きから注文する」バナーを表示する
 modal.addEventListener('close', () => {
   if (!window.previewReady || !window.currentJobId) return;
   const bookSlug = bookSlugEl?.value || 'wimp';
   window.TinyMePreviewResume?.save(bookSlug, {
     jobId: window.currentJobId,
     imageUrl: propPreviewUrl.value,
     formFields: {
       name: nameEl?.value || '',
       gender: getGender(),
       age: ageEl?.value || '',
       birthday_month: monthEl?.value || '',
       birthday_day: dayEl?.value || '',
     },
   });
   window.TinyMePreviewResume?.showBanner({
     bookSlug,
     imageUrl: propPreviewUrl.value,
     onResume: () => restoreFromSaved(window.TinyMePreviewResume.load(bookSlug)),
   });
 });

 // × ボタン・背景クリックでも dialog.close() が走る想定。
 // 外に独立した × ボタンがある場合だけ保険を入れる
 previewCloseBtn?.addEventListener('click', () => modal.close());

  /* ---------- ローダー作成関数 ---------- */
  function createLoaderElement() {
    const loader = document.createElement('div');
    loader.className = 'tm-loader';
    loader.setAttribute('role', 'status');
    loader.setAttribute('aria-live', 'polite');
    loader.setAttribute('data-job-id', window.currentJobId || '');
    
    loader.innerHTML = `
      <div class="tm-loader__row">
        <span class="tm-alive-dot" aria-hidden="true"></span>
        <span class="tm-msg">下描き中…</span>
      </div>
      
      <ul class="tm-steps" aria-hidden="true">
        <li class="is-done">アップロード完了</li>
        <li>色づけ</li>
        <li>仕上げ</li>
      </ul>
      
      <p class="tm-note">ページを開いたままお待ちください</p>
    `;
    
    // ローダーのスタイルを追加
    const style = document.createElement('style');
    style.textContent = `
      .tm-loader {
        margin-top: 12px;
        padding: 12px;
        border: 1px solid #eee;
        border-radius: 12px;
        background: #fff;
      }
      
      .tm-loader__row {
        display: flex;
        align-items: center;
        gap: 8px;
        margin-bottom: 8px;
        font-size: 14px;
      }
      
      .tm-alive-dot {
        width: 8px;
        height: 8px;
        border-radius: 9999px;
        background: currentColor;
        opacity: .8;
        animation: tm-pulse 1.2s ease-in-out infinite;
      }
      
      @keyframes tm-pulse {
        0%, 100% {
          transform: scale(.9);
          opacity: .4;
        }
        50% {
          transform: scale(1.15);
          opacity: 1;
        }
      }
      
      .tm-steps {
        display: flex;
        gap: 12px;
        padding: 8px 0 0;
        margin: 8px 0 0;
        list-style: none;
      }
      
      .tm-steps li {
        position: relative;
        padding-left: 18px;
        color: #6b7280;
        font-size: 12px;
      }
      
      .tm-steps li::before {
        content: "";
        position: absolute;
        left: 0;
        top: 2px;
        width: 12px;
        height: 12px;
        border-radius: 9999px;
        border: 1.5px solid #cbd5e1;
        background: #fff;
      }
      
      .tm-steps li.is-done {
        color: #10b981;
      }
      
      .tm-steps li.is-done::before {
        border-color: #10b981;
        background: #10b981;
        mask: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12"><path fill="white" d="M9.5 3.5 5.25 8 3 5.75l-.75.75L5.25 9.5l5-5z"/></svg>') center/12px 12px no-repeat;
      }
      
      .tm-note {
        margin: 6px 0 0;
        color: #9ca3af;
        font-size: 12px;
      }
      
      @media (prefers-reduced-motion: reduce) {
        .tm-alive-dot {
          animation: none;
        }
      }
    `;
    
    if (!document.querySelector('#tm-loader-styles')) {
      style.id = 'tm-loader-styles';
      document.head.appendChild(style);
    }
    
    return loader;
  }

  /* ---------- 動画モーダル関連関数 ---------- */
  function createVideoModal() {
    if (videoModal) return videoModal;

    // モーダルコンテナ
    videoModal = document.createElement('div');
    videoModal.id = 'video-modal';
    videoModal.style.cssText = `
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.8);
      display: flex;
      justify-content: center;
      align-items: center;
      z-index: 9999;
      opacity: 0;
      transition: opacity 0.3s ease;
    `;

    // モーダルコンテンツ
    const modalContent = document.createElement('div');
    modalContent.style.cssText = `
      background: white;
      border-radius: 12px;
      padding: 20px;
      text-align: center;
      max-width: 90vw;
      max-height: 90vh;
      position: relative;
    `;

    // 動画要素
    videoElement = document.createElement('video');
    videoElement.style.cssText = `
      width: 400px;
      height: 400px;
      max-width: 80vw;
      max-height: 80vw;
      object-fit: cover;
      border-radius: 8px;
    `;
    videoElement.controls = false;
    videoElement.muted = true;
    videoElement.loop = false;
    videoElement.playsInline = true; // iOS 自動再生対策
    videoElement.src = 'https://cdn.shopify.com/videos/c/o/v/a14a7b78786b49d784fde6e9e598d126.mp4';

    // 静止画要素
    imageElement = document.createElement('img');
    imageElement.style.cssText = `
      width: 400px;
      height: 400px;
      max-width: 80vw;
      max-height: 80vw;
      object-fit: cover;
      border-radius: 8px;
      display: none;
    `;
    imageElement.src = 'https://cdn.shopify.com/s/files/1/0758/0522/9311/files/find_the_difference.png?v=1754375942';


    modalContent.appendChild(videoElement);
    modalContent.appendChild(imageElement);
    videoModal.appendChild(modalContent);
    document.body.appendChild(videoModal);

    return videoModal;
  }

  function showVideoModal() {
    const modal = createVideoModal();
    
    // モーダルを表示
    modal.style.opacity = '1';
    
    // 動画を再生
    if (videoElement) {
      videoElement.style.display = 'block';
      imageElement.style.display = 'none';
      videoElement.currentTime = 0;


      // 同期用：回転メッセージ開始トリガを一度だけ投げる
      let rotateMsgStarted = false;
      let rotateTimer = null;
      
      const startRotateMsg = () => {
        if (rotateMsgStarted) return;
        rotateMsgStarted = true;
        document.dispatchEvent(new CustomEvent('tinyme:rotate-msg-start', {
          detail: { jobId: window.currentJobId }
        }));
      };

      // 切り替え処理を関数化（ここで必ず回転メッセージも開始）
      const switchToImage = () => {

        console.log('🎬 switchToImage called');
        
        // 同期のため、まずメッセージ開始
        if (rotateTimer) clearTimeout(rotateTimer);
        startRotateMsg();
        
        // ローダーを表示（動的に作成）
        const stash = document.getElementById('tinyme-loader-stash');
        console.log('📦 stash found:', !!stash);
        
        let loader = stash?.querySelector('.tm-loader');
        if (!loader) {
          // ローダーが存在しない場合は動的に作成
          loader = createLoaderElement();
          if (stash) {
            stash.appendChild(loader);
          }
        }
        
        if (loader) {
          console.log('🔄 loader found/created:', !!loader);
          // modalContentを動的に取得
          const currentModalContent = videoModal?.querySelector('div');
          if (currentModalContent) {
            currentModalContent.appendChild(loader);
            console.log('✅ loader added to modal');
          } else {
            console.error('❌ modalContent not found');
          }
        }
        
        videoElement.pause();
        videoElement.style.display = 'none';
        imageElement.style.display = 'block';
        videoElement.removeEventListener('timeupdate', onTimeUpdate);
        videoElement.removeEventListener('ended', switchToImage);
        isVideoPlaying = false;
      };

      // 動画の長さに応じて切り替え時間を決定
      const SWITCH_SEC = Math.min(24, videoElement.duration || 24);
      console.log('🎬 video duration:', videoElement.duration, 'switch time:', SWITCH_SEC);
      
      // ← ここで"事前に"同時刻のトリガーを予約
      rotateTimer = setTimeout(startRotateMsg, SWITCH_SEC * 1000);
      
      const onTimeUpdate = () => {
        if (videoElement.currentTime >= SWITCH_SEC) {
          switchToImage();
        }
      };

            const onVideoEnded = () => {
        console.log('🏁 video ended, switching to image');
        switchToImage();
      };

      videoElement.addEventListener('timeupdate', onTimeUpdate);
            videoElement.addEventListener('ended', onVideoEnded);

      // 動画の長さが取得できない場合のフォールバック
      if (!videoElement.duration || isNaN(videoElement.duration)) {
        console.log('⚠️ video duration not available, using 24s fallback');
        setTimeout(() => {
          console.log('⏰ fallback timer triggered');
          switchToImage();
        }, 24000);
      }

      // 自動再生を試行
      videoElement.play().then(() => {
        isVideoPlaying = true;
      }).catch(err => {
        console.error('動画再生エラー:', err);
        // 再生できない場合は即静止画へ → 同時に回転メッセージ開始
        if (rotateTimer) clearTimeout(rotateTimer);
        startRotateMsg();
        
        // ローダーを表示（動的に作成）
        const stash = document.getElementById('tinyme-loader-stash');
        
        let loader = stash?.querySelector('.tm-loader');
        if (!loader) {
          // ローダーが存在しない場合は動的に作成
          loader = createLoaderElement();
          if (stash) {
            stash.appendChild(loader);
          }
        }
        
        if (loader) {
          // modalContentを動的に取得
          const currentModalContent = videoModal?.querySelector('div');
          if (currentModalContent) {
            currentModalContent.appendChild(loader);
          }
        }
        videoElement.removeEventListener('timeupdate', onTimeUpdate);
        videoElement.removeEventListener('ended', onVideoEnded);
        videoElement.style.display = 'none';
        imageElement.style.display = 'block';
        isVideoPlaying = false;
      });
    }
  }

  function closeVideoModal() {
    if (videoModal) {
            // ローダーをstashへ戻す（残っている場合のみ）
      const stash = document.getElementById('tinyme-loader-stash');
      const loader = videoModal.querySelector?.('.tm-loader');
      if (loader && stash) stash.appendChild(loader);
     
      videoModal.style.opacity = '0';
      setTimeout(() => {
        if (videoModal && videoModal.parentNode) {
          videoModal.parentNode.removeChild(videoModal);
          videoModal = null;
          videoElement = null;
          imageElement = null;
        }
      }, 300);
    }
    isVideoPlaying = false;
  }
});

} // end _initTinyMeWimp